const Style = {
    shell: 'flex flex-1 flex-col gap-6 lg:flex-row lg:items-start lg:gap-8',
    rail: 'w-full shrink-0 lg:w-52',
    body: 'min-w-0 flex-1 space-y-6',
};

export default Style;
